import React from 'react';
import { HTMLTable } from '@blueprintjs/core';

import FieldDesc from './FieldDesc';
import RenderValue from './RenderValue';

import styles from './CustomDataTable.module.scss';

const CustomDataTable = ({ zones = [], fields = [], hideNa, fluid }) => {
  const cellStyle = fluid ? { width: 'auto' } : {
    width: `${Math.ceil(100 / (zones.length + 1))}%`,
  };

  return (
    <HTMLTable
      bordered
      striped
      condensed
      className={styles.main}
    >
      <tbody>
        {fields.map((field, fieldIndex) => {
          if (zones.every(zone => typeof zone[field] === 'undefined')) {
            return null;
          }

          if (hideNa && zones.every(zone => zone[field] === null)) {
            return null;
          }

          return (
            <tr key={field}>
              <td style={cellStyle}><FieldDesc field={field} /></td>
              {zones.map(zone => (
                <td
                  key={zone.id || JSON.stringify(zone)}
                  style={cellStyle}
                >
                  {zones.length > 1 && zone.color && !fieldIndex && (
                    <div
                      className={styles.color}
                      style={{ color: zone.color }}
                      title={zone.nom_ppal}
                    />
                  )}
                  <RenderValue value={zone[field]} />
                </td>
              ))}
            </tr>
          );
        })}
      </tbody>
    </HTMLTable>
  );
};

export default CustomDataTable;
